export const flowResultStatusList = [
  { label: '很好', value: 1 },
  { label: '良好', value: 2 },
  { label: '一般', value: 3 },
  { label: '不好', value: 4 },
  { label: '无回复', value: 5 }
]
export const judgeOptions = [
  { label: '治愈', value: 2 },
  { label: '失访', value: 3 },
  { label: '无效', value: 4 },
  { label: '有效', value: 5 }
]
